<template>
  <b-container id="app" fluid>
    <div class="content">
      <b-navbar toggleable="md">
        <b-navbar-brand to="/">
          <b-img id="brand" src="/static/img/logo.png" />
        </b-navbar-brand>
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav>
            <b-nav-item to="/">Home</b-nav-item>
            <b-nav-item to="/lifts" v-if="loggedIn">Lifts</b-nav-item>
            <b-nav-item to="/events" v-if="loggedIn">Events</b-nav-item>
            <b-nav-item to="/breakdowns" v-if="loggedIn">Breakdowns</b-nav-item>
            <b-nav-item to="/maintenance" v-if="loggedIn">Maintenance</b-nav-item>
            <!--<b-nav-item v-if="admin" to="/setup">Setup</b-nav-item>-->
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item v-if="admin || groupAdmin" to="/activity">Activity</b-nav-item>
            <b-nav-item v-if="admin || groupAdmin" to="/users">Users</b-nav-item>
            <b-nav-item v-if="admin" to="/groups">Groups</b-nav-item>
            <b-nav-item v-if="loggedIn" @click="openProfile">Profile</b-nav-item>
            <b-nav-item v-if="loggedIn" to="/logout">Logout</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <template ref="viewport" v-if="$route.matched.length">
        <b-row>
          <b-col v-if="loggedIn" align="center" sm="1" style="min-width: 200px">
            <b-row class="statusbox">
              <b-col>
                <a href="/#/lifts">
                  <h1 class="display-5">{{ elevators.length }}</h1>
                  <h6>Total</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[1]" class="operational-online statusbox">
              <b-col>
                <a href="/#/lifts?status=1">
                  <h1>{{ sc[1] }}</h1>
                  <h6>Normal</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[2]" class="operational-offline-2h statusbox">
              <b-col>
                <a href="/#/lifts?status=2">
                  <h1>{{ sc[2] }}</h1>
                  <h6>Offline</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[3]" class="operational-offline-24h statusbox">
              <b-col>
                <a href="/#/lifts?status=3">
                  <h1>{{ sc[3] }}</h1>
                  <h6>Offline 24h</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[7]" class="alarm statusbox statusbox">
              <b-col>
                <a href="/#/lifts?status=7">
                  <h1>{{ sc[7] }}</h1>
                  <h6>Alarm</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[6]" class="fire statusbox statusbox">
              <b-col>
                <a href="/#/lifts?status=6">
                  <h1>{{ sc[6] }}</h1>
                  <h6>Fire recovery</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[5]" class="error statusbox statusbox">
              <b-col>
                <a href="/#/lifts?status=5">
                  <h1>{{ sc[5] }}</h1>
                  <h6>Fault</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[4]" class="shutdown statusbox">
              <b-col>
                <a href="/#/lifts?status=4">
                  <h1>{{ sc[4] }}</h1>
                  <h6>Shutdown</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[-7]" class="inspection-online statusbox">
              <b-col>
                <a href="/#/lifts?status=-7">
                  <h1>{{ sc[-7] }}</h1>
                  <h6>Inspection</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[-5]" class="inspection-offline-2h statusbox">
              <b-col>
                <a href="/#/lifts?status=-5">
                  <h1>{{ sc[-5] }}</h1>
                  <h6>Inspection<br>(Offline)</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[-3]" class="inspection-offline-24h statusbox">
              <b-col>
                <a href="/#/lifts?status=-3">
                  <h1>{{ sc[-3] }}</h1>
                  <h6>Inspection<br>(Offline 24h)</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[-6]" class="maintenance-online statusbox">
              <b-col>
                <a href="/#/lifts?status=-6">
                  <h1>{{ sc[-6] }}</h1>
                  <h6>Maintenance</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[-4]" class="maintenance-offline-2h statusbox">
              <b-col>
                <a href="/#/lifts?status=-4">
                  <h1>{{ sc[-4] }}</h1>
                  <h6>Maintenance<br>(Offline)</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[-2]" class="maintenance-offline-24h statusbox">
              <b-col>
                <a href="/#/lifts?status=-2">
                  <h1>{{ sc[-2] }}</h1>
                  <h6>Maintenance<br>(Offline 24h)</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[8]" class="evac statusbox statusbox">
              <b-col>
                <a href="/#/lifts?status=8">
                  <h1>{{ sc[8] }}</h1>
                  <h6>Removed from service</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[9]" class="poweroff statusbox statusbox">
              <b-col>
                <a href="/#/lifts?status=9">
                  <h1>{{ sc[9] }}</h1>
                  <h6>Power lost</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[-1]" class="repair statusbox">
              <b-col>
                <a href="/#/lifts?status=-1">
                  <h1>{{ sc[-1] }}</h1>
                  <h6>Disabled</h6>
                </a>
              </b-col>
            </b-row>

            <b-row v-if="sc[0]" class="unknown statusbox">
              <b-col>
                <a href="/#/lifts?status=0">
                  <h1>{{ sc[0] }}</h1>
                  <h6>Unknown</h6>
                </a>
              </b-col>
            </b-row>
          </b-col>

          <b-col>
            <router-view v-if="!loggedIn || (loggedIn && settingsLoaded)" :elevators="elevators" :groups="groups"
              :settings="settings" :elevators-loaded="elevatorsLoaded" :groups-loaded="groupsLoaded"></router-view>
          </b-col>
        </b-row>
      </template>
    </div>

    <footer class="footer text-muted">v{{ version }}</footer>

    <b-modal id="profileModal" title="Profile" @ok="saveProfile" ok-title="Save">
      <b-alert v-if="profileAlert" show variant="danger">{{ profileAlert }}</b-alert>
      <b-form-group label="New password" label-for="profilePassword">
        <b-form-input id="profilePassword" type="password" v-model="profile.password"
          autocomplete="new-password"></b-form-input>
      </b-form-group>
      <b-form-group label="Confirm password" label-for="profilePasswordConfirmation">
        <b-form-input id="profilePasswordConfirmation" type="password" v-model="profile.passwordConfirmation"
          autocomplete="new-password"></b-form-input>
      </b-form-group>
      <b-form-group label="E-mail" label-for="profileEmail">
        <b-form-input id="profileEmail" type="text" v-model="profile.email"></b-form-input>
      </b-form-group>
      <b-form-group label="Confirm email" label-for="profileEmailConfirmation">
        <b-form-input id="profileEmailConfirmation" type="text" v-model="profile.emailConfirmation"></b-form-input>
      </b-form-group>
      <b-form-group label="E-mail notifications">
        <b-form-checkbox v-model="profile.notify"></b-form-checkbox>
      </b-form-group>
      <b-form-group label="E-mail notification breakdown duration threshold" label-for="profileNotifyDelay"
        description="Minimum 1 minute">
        <b-input-group append="minutes">
          <b-form-input id="profileNotifyDelay" type="number" min="1"
            v-model.number="profile.notify_delay"></b-form-input>
        </b-input-group>
      </b-form-group>
      <b-form-group v-if="profile.ignoredElevators && profile.ignoredElevators.length" label="Disabled notifications">
        <b-list-group>
          <b-list-group-item v-for="ie in profile.ignoredElevators" :key="ie.elevator_id"
            class="d-flex justify-content-between align-items-center">
            <span
              :style="profile.elevatorRemovals.includes(ie.elevator_id) ? 'text-decoration:line-through;color:#aaa' : ''">{{
                ie.elevator_name || ie.elevator_id }}</span>
            <b-button v-if="!profile.elevatorRemovals.includes(ie.elevator_id)" size="sm" variant="outline-danger"
              @click="markIgnoredElevatorForRemoval(ie.elevator_id)">Remove</b-button>
            <b-button v-else size="sm" variant="outline-secondary"
              @click="unmarkIgnoredElevatorForRemoval(ie.elevator_id)">Undo</b-button>
          </b-list-group-item>
        </b-list-group>
      </b-form-group>
    </b-modal>
  </b-container>
</template>

<script>
import api from './api.js'
import auth from './auth.js'
import { openWS } from './ws.js'

import ElevatorsStatusSmall from './ElevatorsStatusSmall.vue'

import formatter from './formatter.mixin.js';

export default {
  name: 'app',
  components: {
    'elevators-status-small': ElevatorsStatusSmall,
  },
  mixins: [formatter],
  data() {
    return {
      elevators: [],
      elevatorsLoaded: false,
      elevatorsWS: null,
      groups: [],
      groupsLoaded: false,
      loaded: false,
      loggedIn: false,
      admin: false,
      groupAdmin: false,
      version: appVersion,
      settings: {},
      settingsLoaded: false,
      profile: {
        password: '',
        passwordConfirmation: '',
        email: '',
        emailConfirmation: '',
        notify: false,
        notify_delay: 5,
        ignoredElevators: [],
        elevatorRemovals: [],
      },
      profileAlert: '',
    }
  },
  computed: {
    groupsWithElevators: function () {
      if (this.groups) {
        return this.groups.filter(g => g.elevators.length > 0 && !g.hidden);
      }
    },

    sc() {
      const counts = {};
      for (const e of this.elevators) {
        counts[e.status] = (counts[e.status] || 0) + 1;
      }
      return counts;
    },
  },
  methods: {
    init() {
      var a = this;

      api.getSettings(settings => {
        if (settings.data) {
          a.settings = settings.data;
          a.settingsLoaded = true;
        } else {
          a.settings = {};
          a.settingsLoaded = true;
        }

        a.getElevators();
        a.connectElevatorsWS();
        a.scheduleMidnightRefresh();

        a.getGroups();

        a.$root.$on('get-elevators', function () {
          a.getElevators();
        });

        a.$root.$on('get-groups', function () {
          a.getGroups();
        });

        a.loaded = true;
      });

    },

    scheduleMidnightRefresh() {
      if (this.midnightTimer) clearTimeout(this.midnightTimer);
      const now = new Date();
      const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      const msUntilMidnight = tomorrow - now;
      this.midnightTimer = setTimeout(() => {
        this.getElevators();
        this.scheduleMidnightRefresh();
      }, msUntilMidnight);
    },

    connectElevatorsWS() {
      this.elevatorsWS = openWS('/api/v1/ws', (msg) => {
        if (msg.type === 'elevator_update') {
          this.handleElevatorUpdate(msg.data);
        } else if (msg.type === 'groups_changed') {
          this.getGroups();
          this.getElevators();
        } else if (msg.type === 'elevator_outage' && msg.data) {
          this.$root.$emit('elevator-outage', msg.data);
        } else if (msg.type === 'elevator_event' && msg.data) {
          this.$root.$emit('elevator-event', msg.data);
        }
      }, () => {
        this.getElevators();
        this.getGroups();
      });
    },

    handleElevatorUpdate(update) {
      // eslint-disable-next-line eqeqeq
      const idx = this.elevators.findIndex(e => e.id == update.id);
      if (idx === -1) return;
      const existing = this.elevators[idx];
      const merged = Object.assign({}, update);
      // stopsIncrement is a delta from logd; add to existing count rather than replacing
      if (merged.stopsIncrement !== undefined) {
        merged.stopsToday = (existing.stopsToday || 0) + merged.stopsIncrement;
        delete merged.stopsIncrement;
      }
      // dropsIncrement is a delta; add to existing dropsToday so the frontend
      // timezone determines the "today" boundary rather than the server's UTC clock
      if (merged.dropsIncrement !== undefined) {
        merged.dropsToday = (existing.dropsToday || 0) + merged.dropsIncrement;
        delete merged.dropsIncrement;
      }
      const elevator = Object.assign({}, existing, merged, {
        estimatedDate: update.estimatedDate !== undefined ? update.estimatedDate : existing.estimatedDate,
        plannedDate: update.plannedDate !== undefined ? update.plannedDate : existing.plannedDate,
        avgTripsPerDay: update.avgTripsPerDay !== undefined ? update.avgTripsPerDay : existing.avgTripsPerDay,
      });
      this.$set(this.elevators, idx, elevator);
      this.$root.$emit('elevator-update', update);

      // Also update the elevator inside each group so the dashboard pie charts react.
      this.groups.forEach((group, gIdx) => {
        // eslint-disable-next-line eqeqeq
        const eIdx = group.elevators.findIndex(e => e.id == update.id);
        if (eIdx === -1) return;
        const updatedGroup = Object.assign({}, group, {
          elevators: group.elevators.slice(),
        });
        updatedGroup.elevators[eIdx] = elevator;
        this.$set(this.groups, gIdx, updatedGroup);
      });
    },

    getElevators() {
      const window = parseInt(this.settings && this.settings.maintenance_avg_window) || parseInt(localStorage.getItem('maintenanceWindow')) || 30
      api.getElevators(elevators => {
        if (elevators.data) {
          this.elevators = elevators.data;
        } else {
          this.elevators = [];
        }
        this.elevatorsLoaded = true;
      }, window);
    },
    getGroups() {
      api.getGroups(groups => {
        if (groups.data) {
          this.groups = groups.data;
        } else {
          this.groups = [];
        }
        this.groupsLoaded = true;
      });
    },
    openProfile() {
      this.profileAlert = '';
      this.profile.password = '';
      this.profile.passwordConfirmation = '';
      api.getProfile(response => {
        if (response.data) {
          this.profile.email = response.data.email || '';
          this.profile.emailConfirmation = '';
          this.profile.notify = response.data.notify || false;
          this.profile.notify_delay = response.data.notify_delay != null ? response.data.notify_delay : 5;
          this.profile.ignoredElevators = response.data.ignored_elevators || [];
          this.profile.elevatorRemovals = [];
        }
        this.$bvModal.show('profileModal');
      });
    },
    saveProfile(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.profileAlert = '';
      if (this.profile.emailConfirmation !== '' && this.profile.email !== this.profile.emailConfirmation) {
        this.profileAlert = 'Email addresses do not match.';
        return;
      }
      if (this.profile.notify_delay < 1) {
        this.profileAlert = 'E-mail notification breakdown duration threshold must be at least 1 minute.';
        return;
      }
      api.updateProfile(this.profile, response => {
        if (response.data === 'OK') {
          const removals = [...this.profile.elevatorRemovals];
          removals.forEach(id => api.unignoreElevator(id, () => { }));
          this.$bvModal.hide('profileModal');
        } else {
          this.profileAlert = response.data.message || 'Error saving profile.';
        }
      });
    },
    markIgnoredElevatorForRemoval(elevatorID) {
      this.profile.elevatorRemovals.push(elevatorID);
    },
    unmarkIgnoredElevatorForRemoval(elevatorID) {
      this.profile.elevatorRemovals = this.profile.elevatorRemovals.filter(id => id !== elevatorID);
    },
  },

  created() {
    auth.onChange = loggedIn => {
      this.loggedIn = loggedIn;
      this.admin = auth.admin();
      this.groupAdmin = auth.groupAdmin();
      this.version = appVersion;

      if (!loggedIn) {
        this.admin = false;
        this.groupAdmin = false;
        this.loaded = false;
        this.$router.replace('/login')
        return
      }

      this.init()
    }

    this.loggedIn = auth.loggedIn();
    this.admin = auth.admin();
    this.groupAdmin = auth.groupAdmin();
    this.version = appVersion;

    if (!this.loggedIn) {
      this.admin = false;
      this.loaded = false;
      this.$router.replace('/login')
      return
    }

    this.init()
  },

  beforeDestroy() {
    if (this.elevatorsWS) this.elevatorsWS.close();
    if (this.midnightTimer) clearTimeout(this.midnightTimer);
  },
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

a {
  color: inherit;
  text-decoration: inherit;
}

a:hover {
  color: inherit;
  text-decoration: inherit;
}

#app {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content {
  flex: 1 0 auto;
}

.footer {
  flex-shrink: 0;
}

#brand {
  height: 2.5rem;
}

footer {
  margin-top: 5em;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.total {}

.poweroff {
  fill: #cc3300 !important;
  background-color: #cc3300;
}

.evac {
  fill: #cc3300 !important;
  background-color: #cc3300;
}

.alarm {
  fill: #cc3300 !important;
  background-color: #cc3300;
}

.fire {
  fill: #cc3300 !important;
  background-color: #cc3300;
}

.error {
  fill: #cc3300 !important;
  background-color: #cc3300;
}

.shutdown {
  fill: #ff9999 !important;
  background-color: #ff9999;
}

.operational-offline-24h {
  fill: #ff9900 !important;
  background-color: #ff9900;
}

.operational-offline-2h {
  fill: #ffff33 !important;
  background-color: #ffff33;
}

.operational-online {
  fill: #00cc33;
  background-color: #00cc33;
}

.unknown {
  fill: #cccccc !important;
  background-color: #cccccc;
}

.repair {
  fill: #cc99ff !important;
  background-color: #cc99ff;
}

.maintenance-offline-24h {
  fill: #cc99ff !important;
  background-color: #cc99ff;
}

.inspection-offline-24h {
  fill: #cc99ff !important;
  background-color: #cc99ff;
}

.maintenance-offline-2h {
  fill: #cc99ff !important;
  background-color: #cc99ff;
}

.inspection-offline-2h {
  fill: #cc99ff !important;
  background-color: #cc99ff;
}

.maintenance-online {
  fill: #0099ff !important;
  background-color: #0099ff;
}

.inspection-online {
  fill: #0099ff !important;
  background-color: #0099ff;
}

.statusbox {
  margin-left: 2em;
  margin-right: 2em;
  margin-bottom: 1em;
  margin-top: 1em;

  padding-top: 1em;
  padding-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue